import React from 'react';
type IconComponent = React.ComponentType<{
  className?: string;
  'aria-hidden'?: boolean;
}>;
interface SectionHeadingProps {
  badge?: string;
  badgeIcon?: IconComponent;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  id?: string;
  tone?: 'dark' | 'light';
}

/** Clinical blue accent used inside section titles. */
export function Accent({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="text-ember-500" data-id="element-150" data-mp="bk3nfjximv7t">{children}</span>;
}
export function SectionHeading({
  badge,
  badgeIcon: BadgeIcon,
  title,
  subtitle,
  id,
  tone = 'dark'
}: SectionHeadingProps) {
  const titleColor = tone === 'dark' ? 'text-forest-800' : 'text-cream-50';
  const subColor = tone === 'dark' ? 'text-forest-700/85' : 'text-cream-100/80';
  return <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-151" data-mp="6raj2x5ylow9">
      {badge ? <span className="inline-flex items-center gap-2 rounded-full bg-cream-200 px-5 py-2 text-xs font-bold uppercase tracking-[0.16em] text-forest-600" data-id="element-152" data-mp="uhelj17evilo">
          {BadgeIcon ? <BadgeIcon className="h-3.5 w-3.5 text-ember-500" aria-hidden={true} data-id="element-153" data-mp="1tah279yfhr0f" /> : null}
          {badge}
        </span> : null}
      <h2 id={id} className={`${badge ? 'mt-4' : ''} font-display text-3xl font-bold uppercase leading-[1.08] tracking-tight sm:text-4xl lg:text-[2.75rem] ${titleColor}`} data-id="element-154" data-mp="1o91k9qrjs0m9">
        {title}
      </h2>
      {subtitle ? <p className={`mt-4 text-base leading-relaxed sm:text-lg ${subColor}`} data-id="element-155" data-mp="2bz5jzn1m7g7z">{subtitle}</p> : null}
    </div>;
}